import { Group, Stack, Text, Tooltip, useMantineTheme } from '@mantine/core';
import React from 'react';
import { errorBoundaryWrapper } from '@repo/utils';
import { useThemeContext } from '../theme/ThemeContext';
import { IconClockEdit } from '@tabler/icons-react';

/**
 * Renders a labeled form field wrapper, showing the field title above its children with a required-field asterisk and a "changed" indicator/tooltip when the value has been edited from its original state.
 *
 * @param title - Label text displayed above the field.
 * @param isChanged - Whether the field's value has been edited, showing a clock icon and hover tooltip.
 * @param children - The form input element(s) to render below the title.
 */
const DetailsInput = ({ title, isChanged = false, children }: { title: string; isChanged?: boolean; children: any; }) => {

  const textStyle = { marginTop: 10 };
  // const textStyle = { borderTop: `1px solid ${theme.detailsOverviewItemUnderlineColor}`, marginTop: 10 };
  const isRequired = React.Children.toArray(children).some((child => {
    if (React.isValidElement(child)) {
      return child.props.required || child.props.withAsterisk;
    }
    return false;
  }));

  const isChangedProperties = {
    tooltipLabel: 'This item has been edited from its original value. Click to open change log for details',
    groupStyles: { cursor: 'pointer' },
    tooltipStyles: { display: isChanged ? 'block' : 'none' },
    onClick: () => alert('You clicked it!')
  }

  return (
    <Tooltip label={isChanged ? isChangedProperties.tooltipLabel : ''} style={isChangedProperties.tooltipStyles}>
      <Group m={10} justify="left" grow style={isChanged ? isChangedProperties.groupStyles : undefined} onClick={isChanged ? isChangedProperties.onClick : undefined}>
        <Stack gap={'xs'}>
          <div style={textStyle}>
            <Group gap={2}>
              <Text bg={isChanged ? 'blue.1' : undefined} size={'xs'} opacity={1}>{title}</Text>
              {isRequired && <Text c={'red'} size={'xs'}>*</Text>}
              {isChanged && (<IconClockEdit size={15} />)}
            </Group>
          </div>
          {children}
        </Stack>
      </Group>
    </Tooltip>
  );
};

export default errorBoundaryWrapper(DetailsInput);